import { Outlet, useNavigate } from "react-router-dom";
import { MainLayout } from "@cloudaccelerator-ui/react-library";

export interface IAppLayoutProps {
  /** Combined UHF shell API URL */
  uhfApiUrl?: string;
  /** Current environment name (e.g. 'dev', 'prod') */
  envName?: string;
  /** Custom background color for the UHF app navigation bar */
  navbarColor?: string;
}

/**
 * Application layout wrapper that combines the library's MainLayout
 * in UHF mode (Universal Header/Footer) with React Router's Outlet
 * for nested routes.
 */
export function AppLayout({
  uhfApiUrl,
  envName,
  navbarColor,
}: IAppLayoutProps): React.ReactElement {
  const navigate = useNavigate();

  return (
    <MainLayout
      headerProps={{
        uhfApiUrl,
        title: "Incentive Modeler",
        envName,
        navbarColor,
      }}
      footerProps={{
        uhfApiUrl,
        onLocaleClick: (): void => { navigate("/locale"); },
      }}
    >
      <Outlet />
    </MainLayout>
  );
}
